import axios from "axios";
import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    users: [],
    user: {},
    roles: [],
    modalAction: {
      action: "",
      modal_title: "",
      modal_butotn: "",
    },
    response: {
      status: null,
      message: null,
      error: [],
    },
    totalData: 0,
    current: 1,
    perPage: 25,
    sort: "",
    searchQuery: "",
  }),

  actions: {
    openForm(newAction, user) {
      this.modalAction.action = newAction;
      this.user = user;
    },

    async getUsers() {
      const params = new URLSearchParams({
        current: this.current,
        per_page: this.perPage,
        name: this.searchQuery,
      });

      if(this.sort !== '') params.append('sort', this.sort);

      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/users`, {
          params,
        });

        const usersDataList = res.data.data.list;
        this.users = usersDataList;
        this.totalData = res.data.data.meta.total;

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async changePage(newPage) {
      this.current = newPage;
      await this.getUsers();
    },

    async searchUsers(query) {
      this.searchQuery = query;
      this.current = 1;
      await this.getUsers();
    },

    async getUserById(id) {
      try {
        const url = `${this.apiUrl}/${id}`;
        const res = await axios.get(url);

        this.user = {
          ...res.data,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async addUsers(users) {
      try {
        const res = await axios.post(`${this.apiUrl}/api/v1/users`, users, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
        console.log(error);
      }
    },

    async updateUser(users) {
      try {
        const res = await axios.put(`${this.apiUrl}/api/v1/users`, users, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async deleteUser(id) {
      try {
        const url = `${this.apiUrl}/api/v1/users/${id}`;
        await axios.delete(url);
        this.getUsers();

        this.response = {
          status: 200,
          message: "User deleted successfully",
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    resetState() {
      this.users = [];
      this.modalAction = {
        action: "",
        modal_title: "",
        modal_button: "",
      };
      this.response = {
        status: null,
        message: null,
        error: [],
      };
      this.totalData = 0;
    },
  },
});
